export const SET_PRISMIC_DOCUMENT_UID = 'SET_PRISMIC_DOCUMENT_UID';

export function setPrismicDocumentUid(uid) {
  return {
    type: SET_PRISMIC_DOCUMENT_UID,
    payload: {
      prismicDocumentUid: uid
    }
  };
}
